import env from "./environment";

export const DSN = env.SENTRY_DSN;
export const ENVIRONMENT = env.ENVIRONMENT;
export const RELEASE = env.SENTRY_RELEASE;
